module.exports = __webpack_public_path__ + "static/media/ai.0891577a.svg";